// extracted by mini-css-extract-plugin
export default {"social-media-links":"prghQTq","social-media-links__list":"Mj1rppR","social-media-links__item":"Cuo_qDF"};